<div class="report-page-root-container ytd-result-by-branch-component-container ">
  <div class="page-content">
    <div class="page-header">
      <svg class="icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48" id="volume-analysis" style="width:27px">
        <path
          d="M7,25.08H5V13a3,3,0,0,1,3-3H23v2H8a1,1,0,0,0-1,1ZM45,38H43V29H41v9H7V35H21V33H3v2H5v3H3a1,1,0,0,0-1,1v2a5,5,0,0,0,5,5H41a5,5,0,0,0,5-5V39A1,1,0,0,0,45,38ZM24,10H46V25a3,3,0,0,1-3,3H27a3,3,0,0,1-3-3Zm5,5H41V13H29Zm0,4H41V17H29Zm0,4H41V21H29ZM46,5V8H24V5a3,3,0,0,1,3-3H43A3,3,0,0,1,46,5ZM31,4H28V6h3Zm5,0H33V6h3ZM11,27a1,1,0,0,0-1-1H6a1,1,0,0,0-1,1v5h6Zm3-6a1,1,0,0,0-1,1V32h6V22a1,1,0,0,0-1-1Z"
          data-name="33 Volume Analysis, Bar Chart, Bar Graph, Column Graph, Graphical Representation">
        </path>
      </svg>
      <div class="title">
        {{title}}
      </div>
      <div class="action-btn-container">
        @if(permission.can_export || permission.can_execute){
        <button mat-button color="accent" class="action-btn btn-export" (click)="exportClicked()"
          [disabled]="IsDownloading">
          <img class="download-icon" [src]="
              IsDownloading
                ? 'assets/images/animated/download/download-anim.svg'
                : 'assets/images/animated/download/download-no-anim.svg'
            " />
          <span class="action-btn-title">Export</span>
        </button>
        }
        @if(permission.can_view){
        <button mat-flat-button class="action-btn btn-view" (click)="navigateToWeeklyReport()">View</button>
        }
      </div>
    </div>
    <div class="page-details">
      <form class="edit-form" [formGroup]="editForm">
        <div class="detail-section">
          <div class="content-container">
            <div class="row">
              <!-- <div class="input-box-left"> -->
              <mat-form-field>
                <mat-label>Year</mat-label>
                <mat-select placeholder="Select a year" formControlName="year" (selectionChange)="onYearChange()">
                  <!-- Show loading state while waiting for data -->

                  <mat-option *ngFor="let fy of financialYears" [value]="fy.year">
                    {{ fy.display_year }}
                  </mat-option>
                </mat-select>
              </mat-form-field>

              <!-- </div> -->

              <!-- <div class="input-box-right"> -->
              <mat-form-field class="week-selection">
                <mat-label>Week No</mat-label>
                <mat-select formControlName="week_no">
                  <mat-option *ngFor="let week of weeks" [value]="week.week_no">
                    {{ week.displayText }}
                  </mat-option>
                </mat-select>
              </mat-form-field>
              <!-- </div> -->

            </div>



            <!-- Updated Drop/Reset Shop List UI -->

            <div class="list-row shops">
              <div class="header" (click)="isExpandedShop = !isExpandedShop">
                <div class="title-container">
                  <span class="title">Shops</span>
                  <span class="count" *ngIf="selectedShopSourcesCount > 0">
                    [ {{selectedShopSourcesCount}} ]
                  </span>
                </div>
                <div class="toggle-action-container">
                  <button *ngIf="isExpandedShop" class="list-action-button"
                    (click)="showSelectedShopOnly = !showSelectedShopOnly"
                    [title]="showSelectedShopOnly ? 'Show All' : 'Show Selected Only'">
                    <mat-icon>{{ showSelectedShopOnly ? 'visibility_off' : 'visibility' }}</mat-icon>
                  </button>
                  <button *ngIf="isExpandedShop" class="list-action-button" (click)="toggleSelectAllShop()"
                    title="Select All/None">
                    <mat-icon>{{ getSelectAllIconShop() }}</mat-icon>
                  </button>
                  <button class="list-action-button" (click)="isExpandedShop = !isExpandedShop">
                    <mat-icon>{{ isExpandedShop ? 'expand_less' : 'expand_more' }}</mat-icon>
                  </button>
                </div>
              </div>

              <div *ngIf="isExpandedShop" class="list">
                <div class="item-list">
                  <div class="content-filter">
                    <mat-form-field style="width: 100%;" class="hide-subscript-wrapper">
                      <input matInput placeholder="Filter shops" formControlName="shopFilterAll">
                      <button *ngIf="editForm.get('shopFilterAll')?.value" matSuffix mat-icon-button aria-label="Clear"
                        (click)="editForm.get('shopFilterAll')?.setValue('')">
                        <mat-icon>close</mat-icon>
                      </button>
                    </mat-form-field>
                  </div>
                  <div class="content">
                    <ng-container *ngFor="let item of filteredShopListData">
                      <div class="list-item" (click)="item.selected = !item.selected; onShopSelectionChange()">
                        <mat-checkbox [checked]="item.selected" (click)="$event.stopPropagation()"
                          (change)="item.selected = !item.selected; onShopSelectionChange()">
                          {{ item.item.name }}
                        </mat-checkbox>
                      </div>
                    </ng-container>
                  </div>
                </div>
              </div>
            </div>
            <!-- End Drop/Reset Shop List UI -->

            <div class="row">
              <!-- <div> -->
              <mat-form-field class="sort-order">
                <mat-label>Sort Order</mat-label>
                <mat-select formControlName="sort_order">
                  <mat-option *ngFor="let option of sortOrderOptions" [value]="option.value">
                    {{ option.label }}
                  </mat-option>
                </mat-select>
              </mat-form-field>
              <mat-form-field class="sort-by">
                <mat-label>Sort By</mat-label>
                <mat-select formControlName="sort_by">
                  <mat-option *ngFor="let option of sortOptions" [value]="option.value">
                    {{ option.label }}
                  </mat-option>
                </mat-select>
              </mat-form-field>
            </div>
          </div>
        </div>
      </form>
    </div>
  </div>
</div>